import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MasterdataComponent } from './masterdata/masterdata.component';
import { ContactDataComponent } from './ui/gesellschaft/contact-data/contact-data.component';
import { GesellLogicComponent } from './ui/gesellschaft/gesell-logic/gesell-logic.component';
import { WEGlogicComponent } from './weglogic/weglogic.component';
import { WEGlogicImmoDetailComponent } from './weglogic-immo-detail/weglogic-immo-detail.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { FinishedComponent } from './finished/finished.component';
import { FinishedErrorComponent } from './finished-error/finished-error.component';
import { WelcomeKaufanbotComponent } from './welcome-kaufanbot/welcome-kaufanbot.component';
import { WelcomeSchenkungComponent } from './welcome-schenkung/welcome-schenkung.component';
import { WelcomeMietComponent } from './welcome-miet/welcome-miet.component';
import { StartComponent } from './start/start.component';
import { WelcomeKfzComponent } from './welcome-kfz/welcome-kfz.component';
import { LoadLogicComponent } from './load-logic/load-logic.component';
import { LoadJsonComponent } from './load-json/load-json.component';
import { AuthComponent } from './auth/auth.component';
import { AuthGuard } from './shared/authGuard.service';
import { AuthModule } from './auth/auth.module';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ContractsComponent } from './contracts/contracts.component';
import { ContractDetailsComponent } from './contract-details/contract-details.component';
import { ErrorComponent } from './error/error.component';
import { FinalizeContractComponent } from './finalize-contract/finalize-contract.component';

export const routes: Routes = [
  {
    path: 'error',
    component: ErrorComponent,
    pathMatch: 'full',
  },
  {
    path: 'kaufvertrag/personaldata',
    component: MasterdataComponent,
    pathMatch: 'full',
    data: {type : 'kaufvertrag'},
    canActivate: [AuthGuard]
  },
  {
    path: 'kaufvertrag/personaldata/:userId',
    component: MasterdataComponent,
    pathMatch: 'full',
    data: {type : 'kaufvertrag'},
    canActivate: [AuthGuard]
  },
  {
    path: 'gesellschaftsvertrag/personaldata',
    component: ContactDataComponent,
    pathMatch: 'full',
    data: {type : 'gesellschaftsvertrag'},
    canActivate: [AuthGuard]
  },
  {
    path: 'gesellschaftsvertrag/personaldata/:userId',
    component: ContactDataComponent,
    pathMatch: 'full',
    data: {type : 'gesellschaftsvertrag'},
    canActivate: [AuthGuard]
  },
  {
    path: 'mietvertrag/personaldata',
    component: MasterdataComponent,
    pathMatch: 'full',
    data: {type : 'mietvertrag'},
    canActivate: [AuthGuard]
  },
  {
    path: 'mietvertrag/personaldata/:userId',
    component: MasterdataComponent,
    pathMatch: 'full',
    data: {type : 'mietvertrag'},
    canActivate: [AuthGuard]
  },
  {
    path: 'schenkung/personaldata',
    component: MasterdataComponent,
    pathMatch: 'full',
    data: {type : 'schenkung'},
    canActivate: [AuthGuard]
  },
  {
    path: 'schenkung/personaldata/:userId',
    component: MasterdataComponent,
    pathMatch: 'full',
    data: {type : 'schenkung'},
    canActivate: [AuthGuard]
  },
  {
    path: 'kaufanbot/personaldata',
    component: MasterdataComponent,
    pathMatch: 'full',
    data: {type : 'kaufanbot'},
    canActivate: [AuthGuard]
  },
  {
    path: 'kaufanbot/personaldata/:userId',
    component: MasterdataComponent,
    pathMatch: 'full',
    data: {type : 'kaufanbot'},
    canActivate: [AuthGuard]
  },
  {
    path: 'personaldata',
    component: MasterdataComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard]
  },
  {
    path: 'weglogic',
    component: WEGlogicComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard]
  },
  {
    path: 'weglogic/:userId',
    component: WEGlogicComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard]
  },
  {
    path: 'gesell-logic',
    component: GesellLogicComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard]
  },
  {
    path: 'gesell-logic/:userId',
    component: GesellLogicComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard]
  },
  {
    path: 'weglogicdetail',
    component: WEGlogicImmoDetailComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard]
  },
  {
    path: 'welcome',
    component: WelcomeComponent,
    pathMatch: 'full',
  },
  {
    path: 'kaufanbot/:userId',
    component: WelcomeKaufanbotComponent,
    pathMatch: 'full',
  },
  {
    path: 'kaufanbot',
    component: WelcomeKaufanbotComponent,
    pathMatch: 'full',
  },
  {
    path: 'schenkung/:userId',
    component: WelcomeSchenkungComponent,
    pathMatch: 'full',
  },
  {
    path: 'schenkung',
    component: WelcomeSchenkungComponent,
    pathMatch: 'full',
  },
  {
    path: 'miet/:userId',
    component: WelcomeMietComponent,
    pathMatch: 'full',
  },
  {
    path: 'miet',
    component: WelcomeMietComponent,
    pathMatch: 'full',
  },
  {
    path: 'finish',
    component: FinishedComponent,
    pathMatch: 'full',
  },
  {
    path: 'submiterror',
    component: FinishedErrorComponent,
    pathMatch: 'full',
  },
  {
    path: 'start2',
    component: StartComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard]
  },
  {
    path: 'new-contract',
    component: StartComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard]
  },
  {
    path: 'kfz',
    component: WelcomeKfzComponent,
    pathMatch: 'full',
  },
  {
    path: 'load/:page/:user/:contract', //existierender Vertrag
    component: LoadLogicComponent,
    pathMatch: 'full',
  },
  {
    path: 'new/:page/:user', //neuer Vertrag
    component: LoadLogicComponent,
    pathMatch: 'full',
  },
  {
    path: 'load-json',
    component: LoadJsonComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard]
  },
  {
    path: 'load-json/:postId',
    component: LoadJsonComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard]
  },
  {
    path: 'authentication',
    component: AuthComponent,
    pathMatch: 'full',
  },
  {
    path: 'contracts',
    component: ContractsComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
    data: { heading: 'Contracts' }
  },
  {
    path: 'contracts/:id',
    component: ContractDetailsComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
    data: { heading: 'Contract details' }
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard]
  },
  {
    path: 'finalize-contract',
    component: FinalizeContractComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard]
  },
  {
    path: 'admin-panel/users',
    loadChildren: () => import('./contacts/contacts.module').then(m => m.ContactsModule)
  },
  {
    path: 'users',
    loadChildren: () => import('./contacts/contacts.module').then(m => m.ContactsModule)
  },
  {
    path: 'admin-panel/contacts',
    loadChildren: () => import('./contacts/contacts.module').then(m => m.ContactsModule)
  },
  {
    path: 'admin-panel',
    loadChildren: () => import('./superAdmin/super-admin.module').then(m => m.SuperAdminModule)
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'customers',
    loadChildren: () => import('./ui/vertrags/customers/customers.module').then(m => m.CustomersModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'objects',
    loadChildren: () => import('./ui/vertrags/vertrags.module').then(m => m.VertragsModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'settings',
    loadChildren: () => import('./ui/vertrags/settings/settings.module').then(m => m.SettingsModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'billing',
    loadChildren: () => import('./billing/billing.module').then(m => m.BillingModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'gesellschaft',
    loadChildren: () => import('./ui/gesellschaft/gesellschaft.module').then(m => m.GesellschaftModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'admin',
    redirectTo : 'auth/login'
  },
  {
    path: 'admin/login',
    redirectTo : 'auth/login'
  },
  {
    path: '',
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
